var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import styles from './page-modal.module.css';
import { Arrow } from '@otp/icons';
import { useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { PageModalContext } from './page-modal.context';
export const PageModal = (_a) => {
    var { open, onClose, title, children } = _a, props = __rest(_a, ["open", "onClose", "title", "children"]);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const parentContext = useContext(PageModalContext);
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        parentContext.hideModal();
        return parentContext.showModal;
    }, [parentContext]);
    const hideModal = () => {
        setVisible(false);
    };
    const showModal = () => {
        setVisible(true);
    };
    return (_jsxs(Dialog, Object.assign({ open: open, onClose: onClose, fullScreen: fullScreen, sx: { display: visible ? 'block' : 'none' } }, props, { children: [_jsxs(DialogTitle, { display: "flex", alignItems: "center", variant: "subtitle1", children: [_jsx(IconButton, { "aria-label": "close", onClick: onClose, sx: { padding: 0 }, children: _jsx(Arrow, {}) }), _jsx(Box, { sx: {
                            paddingLeft: 2,
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                        }, children: title })] }), _jsx("div", { className: styles.wrapper, children: _jsx(DialogContent, { className: styles.content, children: _jsx(PageModalContext.Provider, { value: { hideModal, showModal }, children: children }) }) })] })));
};
